"use client";
import { ComingSoon } from "../_components/ComingSoon";

const Page = () => {
  return (
    <ComingSoon
      title="Learn, Listen, Grow"
      subTitle="Tune into engaging episodes filled with insights, interviews, and expert advice. Whether you’re looking for career tips, industry trends, or personal growth strategies, our podcasts have something for everyone. Start listening today!"
      bgColor="#303841"
      tagTitle="Podcast"
      tagScale={0.9}
    />
  );
};

export default Page;
